<template>
    <section class="rating">
        <h2 class="section-title">{{$t("Рейтинг")}}</h2>
        <v-layout row wrap>
            <v-flex sm12 md5
                    mb-3
                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, ' pr-3': $vuetify.breakpoint.mdAndUp}"
            >
                <rating type="organizations" :content="organization_rating" />
            </v-flex>
            <v-flex v-if="user.role && user.role.internal_users_rating && user.role.internal_users_rating.rights.length" sm12 md5
                    mb-3
                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, ' pr-3': $vuetify.breakpoint.mdAndUp}"
            >
                <rating type="all" :content="content" />
            </v-flex>
            <v-flex v-if="user.role && user.role.internal_users_rating && !user.role.internal_users_rating.rights.length" sm12 md5
                    mb-3
                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, ' pr-3': $vuetify.breakpoint.mdAndUp}"
            >
                <rating type="org_employee" :content="company_rating_list" />
            </v-flex>
            <v-flex sm12 md2 mb-3>
                <v-layout row wrap fill-height
                          :class="{'px-3': $vuetify.breakpoint.smAndDown}"
                >
                    <v-flex xs12 sm6 md12
                            :class="{'mb-2': $vuetify.breakpoint.xs, 'pr-3': $vuetify.breakpoint.sm}"
                    >
                        <v-layout wrap fill-height>
                            <router-link v-if="$vuetify.breakpoint.mdAndUp" to="/study" class="layout">
                                <CardBgIcon type='top' :text="$t('Повысить рейтинг')"
                                            icon_name='rating'
                                            class="rating-raise xs6 pt-3"
                                />
                            </router-link>
                            <router-link v-if="$vuetify.breakpoint.smAndDown" to="/study" class="layout">
                                <ButtonRed class="flex xs12">{{$t("Повысить рейтинг")}}</ButtonRed>
                            </router-link>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 sm6 md12
                            :class="{'mt-3': $vuetify.breakpoint.mdAndUp}"
                    >
                        <v-layout wrap fill-height>
                            <router-link v-if="$vuetify.breakpoint.mdAndUp" to="/rating" class="layout">
                                <CardBgIcon v-if="$vuetify.breakpoint.mdAndUp" type='top' :text="$t('Все рейтинги')"
                                            icon_name='arrow-right'
                                            class="rating-all pt-3"
                                />
                            </router-link>
                            <router-link v-if="$vuetify.breakpoint.smAndDown" to="/rating" class="layout">
                                <buttonBdWhite class="flex xs12">{{$t("Все рейтинги")}}</buttonBdWhite>
                            </router-link>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </section>
</template>

<script>
import CardBgIcon from '@/components/ui/buttons/card_bg_icon/card_bg_icon_wrapper';
import {button_red, button_bd_white} from '@/components/ui/buttons/base_buttons.js';
import rating from '@/components/blocks/rating/rating.vue';
import {mapState, mapGetters, mapActions} from 'vuex';

export default {
  components: {
    'ButtonRed'    : button_red,
    'buttonBdWhite': button_bd_white,
    CardBgIcon,
    rating,
  },
  computed: {
    ...mapGetters('Home', {
      content: 'rating',
    }),
    ...mapState('rating', [
      'company_rating_list',
      'organization_rating',
    ]),
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('rating', [
      'rating',
      'company_rating',
    ]),
  },
  async mounted() {
    await this.get_org_rating({});
    await this.get_employees_rating({});
  },
  methods: {
    ...mapActions('rating', [
      'get_org_rating',
      'get_internal_rating',
      'get_employees_rating',
      'get_common_rating',
      'get_company_rating',
    ]),
  },
};
</script>
